<div class="col-md-4 col-sm-12 text-center">
  <ng-container i18n>출시일자</ng-container>:
  {{ this.releaseDate }}
</div>
<div class="col-md-4 col-sm-12 text-center">
  <ng-container i18n>입수방법</ng-container>:
  {{ this.getMethod }}
</div>
<div class="col-md-4 col-sm-12 text-center">
  <ng-container i18n>레어도</ng-container>:
  {{ this.rarity }}
</div>
